import CONSTANT from '@/constant'
import Router from '@/router'
import store from '../store'
import {
  Message
} from 'element-ui'
import eventBus from '@/utils/eventBus'
export default (result) => {
  // 是否有返回值，并且检查状态码是否是成功
  const {
    status
  } = result
  const {
    data,
    code
  } = result.data
  // CONSTANT.AJAX_SUCCESS 以常量形式存储
  if (result && (code === CONSTANT.RES_CODE) && status === CONSTANT.AJAX_SUCCESS) {
    localStorage.removeItem('code')
    if (result.data.msg) {
      Message({
        message: result.data.msg,
        type: 'success'
      })
    }
    return data || result.data || result
  } else if (code === CONSTANT.NO_TOKEN || code === CONSTANT.INVALID_TOKEN) {
    localStorage.setItem('code', code)
    localStorage.removeItem('user')
    sessionStorage.setItem('user', null)
    store.commit('SET_USER', null)
    store.dispatch('logout')
    var isTokenExpired = localStorage.getItem('isTokenExpired')
    if (localStorage.getItem('accessToken')) {
      localStorage.removeItem('accessToken')
      // this.$cookie.delete('token')
      if (isTokenExpired == 1) {
        Message({
          // message: '您的账号存在多人同时登录的异常，如非本人操作，请及时修改密码！',
          message: '登录失效，请重新登录！',
          type: 'error',
          duration: 5000
        })
        localStorage.setItem('isTokenExpired', 2)
      }
    } else {
      localStorage.removeItem('accessToken')
      // this.$cookie.delete('token')
      if (isTokenExpired == 1) {
        Message({
          // message: '您的账号存在多人同时登录的异常，如非本人操作，请及时修改密码！',
          message: '未登录，请登录！',
          type: 'error',
          duration: 5000
        })
        localStorage.setItem('isTokenExpired', 2)
      }
    }
    // Router.push({
    //   path: '/'
    // })
    if (Router.currentRoute.path != '/') {
      eventBus.$emit('show-login')
    }
  } else if (code === CONSTANT.NO_PERMISSION) {
    localStorage.setItem('code', code)
    localStorage.removeItem('user')
    sessionStorage.setItem('user', null)
    store.commit('SET_USER', null)
    store.dispatch('logout')
    localStorage.removeItem('accessToken')
    // this.$cookie.delete('token')
    if (result.data.msg) {
      Message({
        message: result.data.msg,
        type: 'error'
      })
    }
    // Router.push({
    //   path: '/'
    // })
    if (Router.currentRoute.path != '/') {
      eventBus.$emit('show-login')
    }
  } else {
    localStorage.removeItem('code')
    if (result.data.msg) {
      Message({
        message: result.data.msg,
        type: 'error'
      })
    }
  }
}
